import { useSelector } from 'react-redux';
import { RootState } from '../../Redux/store';
import { User } from '../../Models/user.models';

export const useUserStore = () => ({
  user: useSelector((state: RootState) => {
    return state.user as User | null;
  }),
});
